
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("675bx", function(module, exports) {
$parcel$export(module.exports, "AsyncJqlUtils", () => $2fc338e974081e95$export$4a178a021cc96ab5);
$parcel$export(module.exports, "useJqlUtils", () => $2fc338e974081e95$export$c7c2706ff288264f);
$parcel$export(module.exports, "default", () => $2fc338e974081e95$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $2fc338e974081e95$export$4a178a021cc96ab5 = async ()=>{
    const module = await (parcelRequire("5o6jd"));
    const { JqlUtils: JqlUtils } = module;
    return new JqlUtils();
};
const $2fc338e974081e95$export$c7c2706ff288264f = ()=>{
    const [Utils, setUtils] = (0, $eJOHy.useState)();
    const asyncEffect = async ()=>{
        const ResolvedUtils = await $2fc338e974081e95$export$4a178a021cc96ab5();
        setUtils(ResolvedUtils);
    };
    (0, $eJOHy.useEffect)(()=>{
        asyncEffect();
    }, []);
    return Utils;
};
var $2fc338e974081e95$export$2e2bcd8739ae039 = $2fc338e974081e95$export$c7c2706ff288264f;

});
parcelRegister("5o6jd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dADqP").then(()=>parcelRequire('imx7a'));

});



$parcel$global.rlb("8YI3e")
//# sourceMappingURL=use-jql-utils.b5aa5cef.js.map
